import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extractType } from '@atlaskit/link-extractors';
import { ElementName } from '../../constants';
import { extractOwnedBy } from '../../extractors/flexible/utils';
var getSimulatedBetterMetadata = function getSimulatedBetterMetadata(extensionKey, data) {
  var _data$Type$includes, _data$Type;
  var types = data ? extractType(data) : undefined;
  var defaultMetadata = {
    primary: [ElementName.AuthorGroup, ElementName.ModifiedOn]
  };
  switch (extensionKey) {
    case 'bitbucket-object-provider':
    case 'native-bitbucket-object-provider':
      if (types !== null && types !== void 0 && types.includes('atlassian:SourceCodePullRequest')) {
        return {
          primary: [ElementName.AuthorGroup, ElementName.ModifiedOn, ElementName.SubscriberCount, ElementName.State],
          subtitle: [ElementName.SourceBranch, ElementName.TargetBranch]
        };
      }
      if (types !== null && types !== void 0 && types.includes('schema:DigitalDocument')) {
        return {
          primary: [ElementName.LatestCommit, ElementName.CollaboratorGroup, ElementName.ModifiedOn]
        };
      }
      return {
        primary: [ElementName.AuthorGroup, ElementName.ModifiedOn]
      };
    case 'confluence-object-provider':
      var primaryAttribution = data && extractOwnedBy(data) ? ElementName.OwnedByGroup : ElementName.AuthorGroup;
      return {
        primary: [primaryAttribution, ElementName.ModifiedOn],
        tertiary: [ElementName.ReactCount, ElementName.CommentCount, ElementName.ViewCount]
      };
    case 'jira-object-provider':
      var isJiraTask = (_data$Type$includes = data === null || data === void 0 || (_data$Type = data['@type']) === null || _data$Type === void 0 ? void 0 : _data$Type.includes('atlassian:Task')) !== null && _data$Type$includes !== void 0 ? _data$Type$includes : false;
      return _objectSpread(_objectSpread({}, defaultMetadata), isJiraTask && {
        primary: [ElementName.AssignedToGroup, ElementName.State, ElementName.StoryPoints, ElementName.Priority]
      });
    case 'trello-object-provider':
      return {
        primary: [ElementName.CollaboratorGroup, ElementName.State, ElementName.DueOn],
        secondary: [ElementName.ReactCount, ElementName.CommentCount, ElementName.AttachmentCount, ElementName.ChecklistProgress],
        subtitle: [ElementName.Location]
      };
    case 'watermelon-object-provider':
      if (types !== null && types !== void 0 && types.includes('atlassian:Project')) {
        return {
          primary: [ElementName.AuthorGroup, ElementName.ModifiedOn, ElementName.State, ElementName.DueOn]
        };
      }
      return {
        primary: [ElementName.AuthorGroup, ElementName.State, ElementName.DueOn]
      };
    case 'slack-object-provider':
      return {
        primary: [ElementName.AuthorGroup, ElementName.SentOn],
        tertiary: [ElementName.ReactCount, ElementName.CommentCount]
      };
    case 'google-object-provider':
    case 'figma-object-provider':
      return {
        primary: [ElementName.AuthorGroup, ElementName.ModifiedOn]
      };
    default:
      return defaultMetadata;
  }
};
var AvatarGroupsWithNamePrefix = [ElementName.AssignedToGroup, ElementName.OwnedByGroup, ElementName.AuthorGroup];
var toElementItem = function toElementItem(name) {
  var showNamePrefix = AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
  var testId = "".concat(name.toLowerCase(), "-metadata-element");
  return {
    name: name,
    showNamePrefix: showNamePrefix,
    testId: testId
  };
};
var toElementItems = function toElementItems(elementNames) {
  if (!(elementNames !== null && elementNames !== void 0 && elementNames.length)) {
    return;
  }
  return elementNames.filter(function (name) {
    return name in ElementName;
  }).map(toElementItem);
};
export var getMetadata = function getMetadata(extensionKey, data) {
  var metadata = getSimulatedBetterMetadata(extensionKey, data);
  var primary = [].concat(metadata.primary, metadata.tertiary);
  return {
    subtitle: toElementItems(metadata.subtitle),
    primary: toElementItems(primary),
    secondary: toElementItems(metadata.secondary)
  };
};